import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img from "./img/img.png";

export const GiveUpOnExercise = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <img src={img} alt="slimdown" className={styles.image} />

        <div className={styles.hints}>
          <h4>Why do people give up on exercise?</h4>

          <p className={styles.description}>
            <strong>The #1 reason</strong> is starting too big too quickly We're
            not promising quick results, but we're committed to supporting you
            on your journey to achieving your goals.
          </p>
        </div>
      </div>
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
